export default __webpack_public_path__ + "static/media/property_43.0611e954.png";